const bigNumSuffixes = ['', 'k', 'M', 'B', 'T'];

const compactNumber = input => {
  const idx = bigNumSuffixes.findIndex((suffix, exp) => input < 1000 ** (exp + 1));
  return {
    n: input / 1000 ** idx,
    suffix: bigNumSuffixes[idx],
  };
};

/**
 * Format a number in compact form (e.g. 1.5k) with locale-appropriate decimal separator.
 * @param {number} value - Raw value (e.g. 1500)
 * @param {string} [locale='en'] - BCP 47 locale for decimal/grouping
 * @returns {string} e.g. "1.5k" (en) or "1,5k" (es)
 */
export const formatCompact = (value, locale = 'en') => {
  const compact = compactNumber(value);
  const decimals = compact.suffix ? 1 : 0;
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(compact.n);
  return `${formatted}${compact.suffix}`;
};

export default compactNumber;
